import React from 'react';
import {Field, FieldError, FieldLabel} from "@root/server/client/esweb/components/ui/field";
import {Control, Controller, FieldPath} from "react-hook-form";
import {AddressAutocomplete2} from "@root/server/client/esweb/src/pages/web/shared/address-autocomplete2";
import {AddressItem} from "@root/server/routes/web/order_wizard/[order_edit_id]/moving/moving.shared.ts";

let ix = 0;

export function RhfAddressAutocomplete<FORM_TYPE>(params: {
    name: FieldPath<FORM_TYPE>
    label?: string,
    control: Control<FORM_TYPE>,
    placeholder: string,
    className?: string
}) {
    const id = `RhfAddressAutocomplete-${ix++}`;

    const {
        name,
        label,
        control,
        placeholder,
        className
    } = params;

    return <Controller
        {...{control, name}}

        render={({field, fieldState}) => {
            const value = isAddressItem(field.value) ? (field.value as AddressItem) : null

            return (
                <Field data-invalid={fieldState.invalid} {...{className}}>
                    {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
                    <AddressAutocomplete2
                        {...{placeholder}}
                        aria-invalid={fieldState.invalid}
                        id={id}
                        name={field.name}
                        value={value}
                        onAddressChange={field.onChange}
                        onBlur={field.onBlur}
                        ref={field.ref}
                        // hasError={fieldState.invalid}
                    />
                    {fieldState.invalid && (
                        <FieldError errors={[fieldState.error]} />
                    )}
                </Field>
            )
        }}
    />
}



const isAddressItem = (value: unknown): value is AddressItem => {
    return Boolean(value) && typeof value === "object" && "location" in (value as Record<string, unknown>)
}

